export default {
    init() {

        $('body').on('change', '#charge_or_refund input[name="charge_or_refund"]', function () {
            if ($('input[name="charge_or_refund"]:checked').val() == 'refund') {
                $('#order-transaction')
                    .removeAttr('disabled')
                    .attr('required', 'required');
                $('#charge_or_refund_label').text('Refund');
            } else {
                $('#order-transaction')
                    .removeAttr('required')
                    .attr('disabled', 'disabled');
                $('#charge_or_refund_label').text('Charge');
            }
        });

        $('body').on('input', '#user_search', function () {
            $.ajax({
                type: 'post',
                url: '/admin/adjustments_user_search',
                data: ({
                    search: $(this).val()
                }),
                success: function (response) {
                    $("#users_list").empty();
                    response.forEach((item) => {
                        var value = item.first_name + "(ID: " + item.id + ", Email: " + item.email + ")";
                        $("#users_list").append("<option data-id='" + item.id + "' value='" + value + "'></option>");
                    });
                    this.attr("autocomplete", "on");
                },
                error: function (response) {

                },
            });
        });

        $('body').on('change', '#user_search', function (e) {
            var value = $("#user_search").val();
            var id = $('#users_list option').filter(function() {
                return this.value == value;
            }).data('id');
            
            $("#user_id").val(id);

            $.ajax({
                type: 'post',
                url: '/admin/adjustments_organisation_search',
                data: ({
                    user_id: $("#user_id").val()
                }),
                success: function (response) {
                    $("#organisations_list").empty();
                    response.forEach((item) => {
                        var value = item.name + "(ID: " + item.id + ", Address: " + item.address + ")";
                        $("#organisations_list").append("<option data-id='" + item.id + "' value='" + value + "'></option>");
                    });
                    this.attr("autocomplete", "on");
                },
                error: function (response) {

                },
            });
        });

        $('body').on('change', '#organisation_search', function (e) {
            var value = $("#organisation_search").val();
            var id = $('#organisations_list option').filter(function() {
                return this.value == value;
            }).data('id');
            
            $("#adjustments-order-id").val(id);

            $.ajax({
                type: 'post',
                url: '/admin/adjustments_transactions_list',
                data: ({
                    order_id: id
                }),
                success: function (response) {
                    $('#order-transaction').empty();
                    $('#order-transaction').html(response);
                },
                error: function (response) {

                },
            });
        });

        $('body').on('submit', '#charge_or_refund', function () {
            $('#charge_or_refund_submit').attr('disabled', 'disabled');
        });

        this.refundModal();
        this.confirmRefund();
        this.cancelRefundModal();
        this.cancelRefund();
    },

    refundModal() {
        $('body').on('click', '.made_refund', function(e) {
            e.preventDefault();
            $('#refund_error').removeClass('alert-danger');
            $('#refund_error').addClass('d-none');
            let id = $(this).closest('tr').find('.tr_id').text();

            let order_id = $(this).closest('tr').find('.order').text();
            let transaction = $(this).closest('tr').find('.transaction').text();
            let amount = $(this).closest('tr').find('.refund').text();
            let details = $(this).closest('tr').find('.details').text();

            $('.modal').modal('hide');
            $('.confirm_id').html(id);
            $('#confirm_order_id').html(order_id);
            $('#confirm_transaction').html(transaction);
            $('#confirm_amount').html(amount);
            $('#confirm_details').html(details);

            $('#refund_modal').modal('show');

        });
    },

    confirmRefund() {
        let $this = this;
        $('body').on('click', '#confirm_refund_button', function(e) {
            e.preventDefault();
            $('#confirm_refund_button').prop('disabled', true);
            let id = $('#confirm_id').text();
            let order_id = $('#confirm_order_id').text();
            let transaction = $('#confirm_transaction').text();
            let amount = $('#confirm_amount').text();
            let details = $('#confirm_details').text();
            $.ajax({
                type: 'POST',
                url: '/admin/confirm-refund',
                data: ({
                    id: id,
                    order_id: order_id,
                    transaction: transaction,
                    amount: amount,
                    details: details,
                }),
                success: function (response) {
                    $this.refundsList();
                    $('#refund_modal').modal('hide');
                },
                error: function (response) {
                    $('#refund_error').html(response.responseJSON.error);
                    $('#refund_error').addClass('alert-danger');
                    $('#refund_error').removeClass('d-none');
                },
                complete: function (response) {
                    $('#confirm_refund_button').prop('disabled', false);
                },
            });
        });
    },

    cancelRefundModal() {
        $('body').on('click', '.cancel_refund', function(e) {
            e.preventDefault();
            let id = $(this).closest('tr').find('.tr_id').text();
            $('.cancel_id').html(id);
            $('#cancel_refund_modal').modal('show');
        });
    },

    cancelRefund() {
        let $this = this;
        $('body').on('click', '#cancel_refund_button', function(e) {
            e.preventDefault();
            $('#cancel_refund_button').prop('disabled', true);
            let id = $('#cancel_id').text();
            let reason = $('#reason').val();
            $.ajax({
                type: 'POST',
                url: '/admin/cancel-refund',
                data: ({
                    id: id,
                    reason: reason,
                }),
                success: function (response) {
                    $this.refundsList();
                    $('#cancel_refund_modal').modal('hide');
                    Livewire.emit("refund_declined");
                },
                error: function(response) {
                    let errors = response.responseJSON.errors;
                    $.each(errors, function (key) {
                        $('#error_' + key).find('.mb-0').html(errors[key]);
                        $('#error_' + key).toggleClass(['d-none', 'alert-danger']);
                    })
                },
                complete: function (response) {
                    $('#cancel_refund_button').prop('disabled', false);
                },
            });
        });
    },

    refundsList() {
        let params = new URLSearchParams(window.location.search);
        let page = params.get('page');
        $.ajax({
            type: 'GET',
            url: '/admin/refunds',
            data: ({
                list: true,
                page: page,
            }),
            success: function (response) {
                $('tbody').html(response);
            },
        });
    },
}
